var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{ref:"modal-common",attrs:{"id":"ModalCommon","centered":"","title":_vm.title,"ok-title":"확인","ok-only":"","ok-variant":"primary"},on:{"ok":function($event){return _vm.$emit('ok')}}},[_c('div',{staticClass:"msg-wrapper"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.content)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }